import { clone, IFilterControl, IFilterField, IFilterPropertyDictionary } from '../../helpers';
import types from '../types';

interface IPropertyFilterState {
    propertyFilters: IFilterPropertyDictionary
    
}

const initialState:IPropertyFilterState = {
    propertyFilters: {}
};

const propertyFilterReducer = function(state:IPropertyFilterState = initialState, action) {

    let stateClone:IPropertyFilterState = clone(state);

    switch(action.type) {

        case types.ADD_PROPERTY_FILTER_STATE:
            stateClone = setPropertyFilterState(stateClone, action.propertyId, action.filterControls, action.filterFields);
            break;

        case types.CLEAR_PROPERTY_FILTER_STATE:
            stateClone = clearPropertyFilterState(stateClone);
            break;

    }

    return stateClone;
}

let setPropertyFilterState = (state: IPropertyFilterState, propertyId: string, filterControls: IFilterControl[], filterFields: IFilterField[]): IPropertyFilterState => {

    state.propertyFilters[propertyId] = {
        FilterControls: filterControls,
        FilterFields: filterFields
    }

    return state;
};

let clearPropertyFilterState = (state: IPropertyFilterState) => {

    state.propertyFilters = {};

    return state;
}

export default propertyFilterReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/property-filter.ts